import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin.component';
import { CategoriesComponent } from './categories/categories.component';
import { CreateCategoryComponent } from './create-category/create-category.component';
import { NewOrganisationComponent } from './new-organisation/new-organisation.component';
import { AdminOrganisationComponent } from './organisation/organisation.component';
import { OrganisationsComponent } from './organisations/organisations.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  imports: [
    AdminRoutingModule,
    SharedModule,
    RouterModule,
    CommonModule,
    CdkTableModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    AdminComponent,
    AdminOrganisationComponent,
    CategoriesComponent,
    CreateCategoryComponent,
    NewOrganisationComponent,
    OrganisationsComponent
  ],
  entryComponents: [CreateCategoryComponent],
  exports: [AdminComponent],
  providers: []
})
export class AdminModule {}
